/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Back_ButtonInputs */

const en_login_back_button = /** @type {(inputs: Login_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

const fr_login_back_button = /** @type {(inputs: Login_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour`)
};

const de_login_back_button = /** @type {(inputs: Login_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

const it_login_back_button = /** @type {(inputs: Login_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indietro`)
};

const ru_login_back_button = /** @type {(inputs: Login_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назад`)
};

const es_login_back_button = /** @type {(inputs: Login_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atrás`)
};

const zh_cn2_login_back_button = /** @type {(inputs: Login_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`后退`)
};

const ja_login_back_button = /** @type {(inputs: Login_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻る`)
};

const hi_login_back_button = /** @type {(inputs: Login_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पीछे`)
};

const pt_pt2_login_back_button = /** @type {(inputs: Login_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar`)
};

/**
* | output |
* | --- |
* | "Back" |
*
* @param {Login_Back_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_back_button = /** @type {((inputs?: Login_Back_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Back_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_back_button(inputs)
	if (locale === "de") return de_login_back_button(inputs)
	if (locale === "it") return it_login_back_button(inputs)
	if (locale === "ru") return ru_login_back_button(inputs)
	if (locale === "es") return es_login_back_button(inputs)
	if (locale === "zh-CN") return zh_cn2_login_back_button(inputs)
	if (locale === "ja") return ja_login_back_button(inputs)
	if (locale === "hi") return hi_login_back_button(inputs)
	if (locale === "pt-PT") return pt_pt2_login_back_button(inputs)
	return en_login_back_button(inputs)
});